import { Component, OnInit, TemplateRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { CartModuleConsts } from '../../contants';
import { CartService } from '../../services/cart.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Router, RoutesRecognized } from '@angular/router';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { AlertService } from 'src/app/core/services/alert.service';
import { environment } from 'src/environments/environment';
import { filter, pairwise } from 'rxjs/operators';
import { SharedConsts } from 'src/app/shared/constants';



@Component({
    selector: 'app-order-summary',
    templateUrl: './order-summary.component.html',
    styleUrls: ['./order-summary.component.scss'],
    standalone: false
})
export class OrderSummaryComponent implements OnInit {
  previous_url =''
  checkoutDetailsApiSubscribe:any;
  hasAlreadyCheckoutCall = false;
  hasAlreadyGetItemsCall = false;
  page_size = environment.cart_page_size
  imagePath = environment.s3_path + '/' + environment.product_image_folder + '/'
  loading = false;
  componentLoaded = false;
  nextPage = 1;
  productList = []
  totalProductPages = 1;
  totalProductCount = 0;
  noRecord = true;
  orderDetail :any = {};
  global_data :any ={};
  firstHit: any = 1;
  promotionMessage = [];
  show = false;
  bsModalRef: BsModalRef;
  pOForm: FormGroup;
  submitted = false;
  popupMessage = '';
  commonBottonText: any = 'Ok';
  onholdMessage = CartModuleConsts.ONHOLD_MESSAGE;
  onholdMessageWithDepot = CartModuleConsts.ONHOLD_MESSAGE_WITH_DEPOT
  constructor(private statePersist: StatePersistService, private cartService: CartService,
    private titleService: Title, private formBuilder: FormBuilder,
    private modalService: BsModalService, private router: Router,
    private googleAnalyticsService: GoogleAnalyticsService,
    private alertService: AlertService) {
      this.router.events
    .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
    .subscribe((events: RoutesRecognized[]) => {
      this.previous_url = events[0].urlAfterRedirects
      this.statePersist.setLocalStorage('previous_url', this.previous_url)
    });
     }

  popup(template: TemplateRef<any>){
    this.bsModalRef = this.modalService.show(template,  Object.assign({}, { class: 'modal-dialog-centered custom-modal confirm' }));
  }

  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  ngOnInit(): void {
    this.previous_url = this.statePersist.getLocalStorage('previous_url')
    this.titleService.setTitle(CartModuleConsts.ORDER_SUMMARY);
    this.pOForm = this.formBuilder.group({
      po_number: ['', [Validators.required]]
    });

    if (this.previous_url != "/mycart/review") {
      this.router.navigate(['/mycart']);
     } 

    this.statePersist.setLocalStorage('address-disabled', true)
    this.statePersist.setLocalStorage('retailer-disabled', true)
    this.statePersist.setLocalStorage('product_data', {}, 'search')
    this.statePersist.removeLocalStorage('product_data')
    this.statePersist.watchGlobalDataStorage().subscribe(() => {
      this.global_data = this.statePersist.getLocalStorage('global_data')
    })
    this.orderDetail = {};
    this.checkoutDetail('');
    this.getCartItems()
  }

  checkoutDetail(msg){
    this.hasAlreadyCheckoutCall = true
    this.cartService.checkoutDetail()
    .subscribe(
      response => {
          if (response.status == 2212){
            this.alertService.error(response.response)
          }
          this.orderDetail = response.response
          this.promotionMessage = this.orderDetail.one_free_withten_msg
          this.show = false;
          if(this.orderDetail.items_count != '0' && this.orderDetail.min_cases == ''){
            this.firstHit = 1
          }
          if(response.response.cart_item_reload !=null && response.response.cart_item_reload == 'Yes'){
            this.statePersist.emitmyCartData('my cart list update')
          }
          else if (msg.includes('mycart')){
            this.statePersist.emitmyCartData('my cart list update')
          }
          this.hasAlreadyCheckoutCall = false;
        },
        error => { }
    )
  }

  showMore(){
    this.show = !this.show;
  }
  toInteger(value) {
    return parseInt(value)
  }

  redirectToPayment(){
    this.bsModalRef.hide()
    this.router.navigate(['mycart/payment'])
  }

  redirectTo(obj){
    let url;
    if (obj.hyperlink != ''){
      if (obj.search_value != ''){
        this.googleAnalyticsService.eventEmitter(SharedConsts.ORDER_SUMMARY_PROMOTION_CLICK_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.ORDER_SUMMARY_PROMOTION_CLICK_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
        this.statePersist.setLocalStorage('product_data', {'search_keyword':obj.search_value}, 'search')
        url = 'product/listing/All'
        this.router.navigate([url]);
      }
      else{
        url = obj.offer_url
        window.open(
          url, "_blank");
       }
    }
  }

  placeOrder(card_payment, before_payment, check_last_order, popup_24hr_template){

    if (!check_last_order){
      this.bsModalRef.hide();
    }
    this.submitted = true
    if(this.pOForm.invalid && this.orderDetail.is_po_enable){
      return
    }

    if(card_payment == 1){
      before_payment = 'before_payment'
    }

    let po_number;
    let flag, token, savecard;
    po_number = this.pOForm.controls.po_number.value.trim()
    if(this.orderDetail.payment_mode == 'Card'){
      po_number = this.pOForm.controls.po_number.value.trim()
    }
    else{
      po_number = this.pOForm.controls.po_number.value
    }
    this.cartService.placeOrder(this.firstHit, flag, token, savecard, before_payment, po_number, check_last_order)
    .subscribe(
      response => {

        if(this.global_data['payment_mode'] == 'Card'){

        this.statePersist.setLocalStorage('po_number', po_number)
        }
        if (response.status == 1161 || response.status == 1157 || response.status ==1153 || response.status == 2215){
          this.alertService.error(response.response)
        }
        else if (response.status == 2180){
          this.alertService.error(response.response)
          setTimeout(() => {
            this.reloadCurrentRoute()
          }, 300);

        }
        else if (response.status == 403){
          this.router.navigate(['/'])
        }
        else if (response.status == 1180){
            localStorage.setItem('closeStorInfoMessage', response.response.msg)
            setTimeout(() => {
              document.getElementById("openclosedStoreInfo").click();
            }, 100);
        }
        else if (response.status == 1170){
          this.alertService.error(response.response.msg)
          this.getCartItems()
          this.statePersist.emitOrderDetailData('updae order Deatil')
        }
        else if (response.status == 1188) {
          this.popupMessage = response.response.split("<br>").join("\n");
          this.commonBottonText = "Confirm"
          this.popup(popup_24hr_template)
        }
        else if(before_payment != '' && card_payment == 1){
          this.router.navigate(['mycart/payment'])
          }
          else{

            this.orderDetail['order_id'] = response.response.order_id
            this.orderDetail['order_date'] = response.response.order_date
            this.orderDetail['grand_total'] = response.response.grand_total
            this.orderDetail["transaction_payment_id"] = response.response.transaction_payment_id
            this.orderDetail['transaction_date'] = response.response.transaction_date
            this.orderDetail['price_visibility'] = this.global_data['price_visibility']
            this.orderDetail['card_payment'] = card_payment
            this.statePersist.setLocalStorage('order-detail', this.orderDetail)
            this.statePersist.emitminiCartData('mini cart update')
            this.googleAnalyticsService.eventEmitter(SharedConsts.PLACE_ORDER_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.PLACE_ORDER_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
            this.router.navigate(['mycart/order-confirmation'])
          }
        this.firstHit = ''
        },
        error => { }
    )



  }

  ngAfterViewInit(){
    this.checkoutDetailsApiSubscribe = this.statePersist.watchMyOrderDetail().subscribe(message => {

      if (!this.hasAlreadyCheckoutCall)
      {

        this.checkoutDetail(message)
      }

    })
  }

  getCartItems() {
    this.hasAlreadyGetItemsCall = true
    this.cartService.getCartItems({"page_size": this.page_size,'page':this.nextPage, order_summary : true})
    .subscribe(
      data => {
        if (data.response) {
          if (data.status == 2212){
            this.alertService.error(data.response)
          }
          const product_list = data.response.items;
          this.totalProductCount = data.response.product_count
          this.totalProductPages = data.response.total_pages;

          if (this.totalProductPages < this.nextPage + 1) {
            this.nextPage = null;
          }
          else {
            this.nextPage += 1;
          }
          if (data.response.total_product_count === 0) {
            this.noRecord = true;
            this.productList = [];
            this.nextPage = 1;
            this.totalProductCount = 0;
            this.totalProductPages = 1
          }
          else {
            this.noRecord = false;

          }
          for (let i = 0; i < product_list.length; i++) {
            this.productList.push(product_list[i]);
          }
          if (data.response.out_of_stock_remove == 1){
            this.statePersist.emitmobileListCountDetails('mobile count change')
          }
        }
        this.loading = false;
        this.componentLoaded = true;
        this.hasAlreadyGetItemsCall = false;
      }
    );
  }

  onScrollDown() {

    if ((this.nextPage != 1 && this.nextPage !== null) && !this.loading) {
      this.loading = true;
      this.getCartItems()
    }

  }

}
